import {productService} from "@/services/api/productService";
import {getShortOrderType} from "@/utils/orderUtils";
import {mapProductArray} from "@/utils/productUtils";

export default {
  data() {
    return {
      isLoading: false,
      limit: 100,
      offset: 0,
      getDietaryInfo: null,
      searchPhrase: "",
      whereToSearch: 0
    };
  },
  methods: {
    async getCategoryProducts(categoryId, orderType) {
      try {
        this.isLoading = true;

        console.log("Fetching products for category:", categoryId, "with order type:", orderType);

        const result = await productService.getProducts(this.limit, this.offset, window.config.ORDER_PRODUCTS_BY, true, true,
          false, false, false, this.getDietaryInfo, true,
          true, getShortOrderType(orderType), this.searchPhrase, this.whereToSearch, categoryId);

        if (result.exception) {
          this.showError("exceptionMessage");
          return [];
        }
        if (result.errorCode > 0) {
          this.showError(result.errorMsg);
          return [];
        }

        let products = result.products || null;
        if (!products || !Array.isArray(products.productArray)) {
          this.makeToast("danger", this.$t("notification.noProducts"));
          return [];
        }

        if (typeof this.updateFoodPackagingProducts === 'function') {
          //this.updateFoodPackagingProducts(products, false);
          this.updateFoodPackagingProducts(result);
        }

        // Map the productArray to simplified product objects
        return mapProductArray(products.productArray);
      } catch (error) {
        this.makeToast("danger", this.$t("error.general"));
        return [];
      } finally {
        this.isLoading = false;
      }
    },
    showError(messageKey) {
      this.makeToast("danger", this.$t(messageKey));
    }
  }
};
